var map = {
	"./about_brainstorm.svg": 155,
	"./about_design.svg": 156,
	"./about_dev.svg": 157,
	"./about_gadgets.svg": 158,
	"./about_hosting.svg": 159,
	"./about_info.svg": 160,
	"./about_maintenance.svg": 161,
	"./about_requirements.svg": 162,
	"./about_ui.svg": 163,
	"./contact_marker.svg": 213,
	"./detail_left_arrow.svg": 214,
	"./detail_right_arrow.svg": 215,
	"./home_clients.svg": 216,
	"./home_services_dev.svg": 164,
	"./home_services_integ.svg": 165,
	"./home_services_ui.svg": 166,
	"./home_services_web.svg": 167,
	"./logo.svg": 217,
	"./scroll_arrow.svg": 292
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 597;



//////////////////
// WEBPACK FOOTER
// ./src/assets/images nonrecursive \.svg$
// module id = 597
// module chunks = 2